import { numberToPrettyString } from '@cian/utils';

import { getPaymentPeriod } from './getPaymentPeriod';
import { isDailyRent } from './isDailyRent';
import { IOfferCard } from '../../../types';

export function getRentPrice({ category, isCianPartner, bargainTerms: { priceRur } }: IOfferCard): string {
  const shouldAddPretext = isDailyRent(category) && !isCianPartner;

  const price = `${numberToPrettyString(priceRur)} ₽/${getPaymentPeriod(category)}`;

  if (shouldAddPretext) {
    return `от ${price}`;
  }

  return price;
}
